import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disable-failitator',
  templateUrl: './disable-failitator.component.html',
  styleUrls: ['./disable-failitator.component.scss']
})
export class DisableFailitatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
